module.exports = __webpack_public_path__ + "static/img/id.17b99676.svg";